import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { QryDpMsgRes, DpItem } from '@tencent/wphk-components-dp-loader/src/types';
import { to } from '@/utils';
import { CustomException, language } from '@tencent/ppd-base-libs';
import { DetailDialogType } from '../hooks/use-coupon-task-dialog';

/**
 * 从投放中台查询信息
 */
export async function queryInfoFromDp<T>(
  dpPage: string,
  position: string,
  formatFn: (item: DpItem) => T,
): Promise<T[]> {
  const [error, dpMsg] = await to(queryDpMessage({
    dpPage,
    dpPositions: [position],
  }));
  if (error) {
    // 静默处理
    new CustomException(error, 'DpLoaderException', `loader failed for dpPage: ${dpPage}, dpPosition: ${position}`);
    return [];
  }
  return (dpMsg as QryDpMsgRes)?.dpList.map(formatFn);
}


/** 简繁英 */
type ThreeLanguage = {
  /** 繁体 */
  hk: string;
  /** 简体 */
  cn: string;
  /** 英文 */
  en: string;
};
/** 投放中台预期返回的banner位数据格式 */
type ExpectedPropertyForBanner = {
  /** banner图片 */
  imgObj: ThreeLanguage;
  /** 无障碍 */
  bannerAltObj: ThreeLanguage;
  /** 点击上报扩展字段 */
  statClick: string;

  /** H5 banner URL */
  link?: string;

  /** 小程序appid，与username二选一 */
  appid?: string;
  /** 小程序banner，username */
  username?: string;
  /** 小程序banner，path */
  path?: string;

  /** 额外的信息 */
  /** 自定义事件类型 */
  eventType?: DetailDialogType;
  /** 自定义事件 - 券 id */
  couponId?: string;
  /** 自定义事件 - 任务 id */
  taskId?: string;
};

/** bannerdata格式化后的数据 */
export type FormatBannerDataRes = {
  /** banner图片 */
  bannerImgUrl: string;
  /** 点击banner跳转/拉起小程序的信息 */
  bannerJumpInfo: {
    /** 点击跳转H5链接 */
    jumpUrl: string;
    /** 点击拉起小程序-appid */
    miniAppId: string;
    /** 点击拉起小程序-username */
    miniAppUsername: string;
    /** 点击拉起小程序-path */
    miniAppPath: string;
  },
  /** 数据上报扩展字段 */
  bannerTag: string;
  /** 无障碍 */
  bannerAlt: string;
  /** 排序。仅仅是为了@tencent/wphk-components-banner里props需要weight，实际dp不会返回，dp本身排序完成后返回的，有点多余了 */
  weight: number;

  // 自定义事件信息
  extraData: {
    eventType?: 'coupon' | 'task';
    couponId: string;
    taskId: string;
  },
};
/**
 * 格式化投放中台返回的banner数据 或 推荐数据（推荐在投放中台完全用的是banner的组件）
 */
export function formatBannerData(item: DpItem): FormatBannerDataRes {
  const lang = getMapLang();
  const baseData = item.contentBaseData as ExpectedPropertyForBanner;

  return {
    bannerImgUrl: baseData.imgObj[lang],
    bannerJumpInfo: {
      jumpUrl: baseData.link ?? '',
      miniAppId: baseData.appid ?? '',
      miniAppUsername: baseData.username ?? '',
      miniAppPath: baseData.path ?? '',
    },
    bannerTag: baseData.statClick,
    bannerAlt: baseData.bannerAltObj[lang],
    weight: 0,

    // 自定义事件信息
    extraData: {
      eventType: baseData.eventType,
      couponId: baseData.couponId ?? '',
      taskId: baseData.taskId ?? '',
    },
  };
}

/**
 * 语言映射
 */
function getMapLang(): string {
  const LANG_MAP = {
    'zh-cn': 'cn',
    zh_cn: 'cn',
    'zh-hk': 'hk',
    zh_hk: 'hk',
  };

  return LANG_MAP[language.getLanguage()] || 'en';
}

